import { createSlice } from "@reduxjs/toolkit";
import {
  getNotesPaged,
  addNote,
  updateNote
} from "./thunk";

export const initialState = {
  pagedNotes: [],
  paginationNotesInfo: {},
  error: {},
  pageNoteRequest: { page: 1, size: 25, isActive: true, statusFilter: 1, searchInput: null, searchField: null }
};
const NoteSlice = createSlice({
  name: "NoteSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {  

    builder.addCase(getNotesPaged.fulfilled, (state, action) => {
      state.pagedNotes = action.payload.response;
      state.paginationNotesInfo = {
        currentPage: action.payload.page,
        currentPageSize: action.payload.size,
        totalRows: action.payload.totalRows,
        totalPages: action.payload.totalPages
      };
      state.pageNoteRequest = { 
        page: action.payload.page, 
        size: action.payload.size, 
        isActive: action.payload.isActive, 
        statusFilter: action.payload.statusFilter, 
      };

      sessionStorage.setItem("pagedNotes", JSON.stringify(state.pagedNotes));
      sessionStorage.setItem("paginationNotesInfo", JSON.stringify(state.paginationNotesInfo));
      sessionStorage.setItem("pageNoteRequest", JSON.stringify(state.pageNoteRequest));
    });

    builder.addCase(addNote.fulfilled, (state, action) => {
      state.pagedNotes.unshift(action.payload);
      sessionStorage.setItem("pagedNotes", JSON.stringify(state.pagedNotes));
    });

    builder.addCase(updateNote.fulfilled, (state, action) => {
        state.pagedNotes = state.pagedNotes.map(part =>
            part.id === action.payload.id ? { ...part, ...action.payload } : part
        );
        state.pagedNotes = state.pagedNotes.filter(part => part.isActive == state.pageNoteRequest.isActive);
        sessionStorage.setItem("pagedNotes", JSON.stringify(state.pagedNotes));
    });

    builder.addCase(getNotesPaged.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(addNote.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(updateNote.rejected, (state, action) => { state.error = action.payload || null; });
  },
});

export default NoteSlice.reducer;